import React, { useState, useEffect, useContext } from "react";
import { Link, withRouter, useLocation } from "react-router-dom";
import { Icon, notification, Modal, Button, Collapse, Select, Dropdown, Menu } from "antd";
import moment from "moment";
import axios from "axios";

import { LuSend, LuCheck } from "react-icons/lu";

import ModalAta from "../../GerirDetalheTurma/Aproveitamento/Relatorios/Drawer/Ata";
import ParecerAluno from "./_Aux/ParecerAluno";
import ParecerGeral from "./_Aux/ParecerGeral";
import ModalViewer from "../../shared/components/Modals/ModalViewer";
import ModalLoading from "../../shared/components/Modals/ModalLoading";
import FormDrawerAdicionarParecerAnual from "./Drawers/DrawerAdicionarParecerAnual";
import DrawerDataEmissao from "../Aproveitamento/Relatorios/Drawer/Ata";
import InitialsAvatar from "../../shared/components/InitialsAvatar";
import ModalGerarDocumento from "../../shared/components/Modals/GerarDocumento";
import { GlobalContext } from "../../app/providers/GlobalState";
import DrawerLogs from "./Drawers/DrawerLogs";
const { Option } = Select;
const { Panel } = Collapse;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const ListaPareceres = ({ match }) => {
    const [disciplinas, setDisciplinas] = useState([]);
    const [disciplinaId, setDisciplinaId] = useState(
        localStorage.getItem("vista") === "TURMA" ? null : localStorage.getItem("codigo_curso")
    );
    const [periodoId, setPeriodoId] = useState(0);

    const [num, setNum] = useState(1);
    const [total, setTotal] = useState(0);
    const [semPeriodos, setSemPeriodos] = useState(false);
    const [periodos, setPeriodos] = useState([]);
    const [alunoId, setAlunoId] = useState(0);

    // PERIODO
    const [dtInicio, setDtInicio] = useState("");
    const [dtFim, setDtFim] = useState("");
    const [mes, setMes] = useState("");
    const [ano, setAno] = useState("");
    const [titulo, setTitulo] = useState("");
    const [parecer, setParecer] = useState("");
    const [parecerDrawer, setParecerDrawer] = useState({});
    const [geralParecer, setGeralParecer] = useState("");
    const [textoParecerAnual, setTextoParecerAnual] = useState("");
    const [aulasAlunos, setAulasAlunos] = useState([]);
    const [aulas, setAulas] = useState([]);
    const [participantes, setParticipantes] = useState([]);
    const [participantesAnual, setParticipantesAnual] = useState([]);
    const [parecerAnualBloqueado, setParecerAnualBloqueado] = useState(null);
    const [dataParecerAnualBloqueado, setDataParecerAnualBloqueado] = useState(null);
    const [modalBloquearVisible, setModalBloquearVisible] = useState(false);
    const [modalDesbloquearVisible, setModalDesbloquearVisible] = useState(false);
    const [disciplinaNome, setDisciplinaNome] = useState("");
    const [previousLocation, setPreviousLocation] = useState("");
    // LOADING
    const [iconLoading, setIconLoading] = useState(false);

    // EXPORTAR
    const [ataVisible, setAtaVisible] = useState(false);
    const [visibleExportar, setVisibleExportar] = useState(false);
    const [btnDescarregar, setBtnDescarregar] = useState(false);
    const [ficheiroExportar, setFicheiroExportar] = useState("");

    const [visibleLoading, setVisibleLoading] = useState(false);

    // VIEWER
    const [visibleViewer, setVisibleViewer] = useState(false);
    const [drawerAdicionarParecerAnualVisible, setDrawerAdicionarParecerAnualVisible] = useState(false);
    const [dataEmissaoAlunoAnualVisible, setDataEmissaoAlunoAnualVisible] = useState(false);
    const [visibleDrawerLogs, setVisibleDrawerLogs] = useState(false);

    const [docs, setDocs] = useState([]);

    const location = useLocation();

    const context = useContext(GlobalContext);

    const anosEdicao = ["2022", "2023", "2024"];
    const cursoEdicao = localStorage.getItem("curso_edicao");
    const containsEdicao = anosEdicao.some(e => e === cursoEdicao);

    const isEIOuroBrancoAnosPosteriores =
        localStorage.getItem("header_codigo") === "EI" && localStorage.getItem("entidade_id") === "37" && !containsEdicao;

    const tituloPareceres = () => {
        axios({
            method: "get",
            url: "/api/pareceres/titulo-parecer",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setParecer(response.data.parecer);
                setGeralParecer(response.data.parecerGeral);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar o parecer geral!");
            });
    };

    const listarParecerAluno = (disciplinaIdParam, dtInicioParam, dtFimParam) => {
        axios({
            method: "get",
            url: "/api/aulas/listar-pareceres-alunos",
            params: {
                cursoId: disciplinaIdParam,
                dt_inicio: dtInicioParam,
                dt_fim: dtFimParam
            }
        })
            .then(response => {
                setAulasAlunos(response.data.aulas);
                setParticipantes(response.data.participantes);
                setIconLoading(false);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os pareceres!");
            });
    };

    const listarPareceres = (disciplinaIdParam, dtInicioParam, dtFimParam) => {
        axios({
            method: "get",
            url: "/api/aulas/listar-pareceres",
            params: {
                cursoId: disciplinaIdParam,
                dt_inicio: dtInicioParam,
                dt_fim: dtFimParam
            }
        })
            .then(response => {
                setAulas(response.data);
                setIconLoading(false);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os pareceres!");
            });
    };

    const carregarParecerAnual = () => {
        axios({
            method: "get",
            url: "/api/pareceres/carregar-parecer-anual",
            params: {
                turmaId: !disciplinaId ? localStorage.getItem("codigo_curso") : disciplinaId
            }
        })
            .then(response => {
                const participantes = response.data.participantes;
                const parecerAnualBloqueado = response.data.parecerAnualBloqueado;
                const dataParecerAnualBloqueado = response.data.dataParecerAnualBloqueado;

                setDataParecerAnualBloqueado(dataParecerAnualBloqueado);
                setParticipantesAnual(participantes);
                setParecerAnualBloqueado(parecerAnualBloqueado);
                setIconLoading(false);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os pareceres!");
            });
    };

    const alterarAcessoParecerAnual = acesso => {
        axios({
            method: "put",
            url: "/api/pareceres/bloquear-parecer-anual",
            params: {
                cursoId: !disciplinaId ? localStorage.getItem("codigo_curso") : disciplinaId,
                acesso
            }
        })
            .then(response => {
                setParecerAnualBloqueado(acesso);
                setDataParecerAnualBloqueado(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível bloquear os pareceres!");
            });
    };

    const fetchTotal = () => {
        setIconLoading(true);

        axios({
            method: "get",
            url: "/api/aulas/total-periodos-observacoes",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                if (response.data.length > 0) {
                    const firstPeriodo = response.data[0];

                    setPeriodos(response.data);
                    setPeriodoId(firstPeriodo.id);
                    setTitulo(firstPeriodo.titulo);
                    setDtInicio(firstPeriodo.dt_inicio);
                    setDtFim(firstPeriodo.dt_fim);

                    if (!localStorage.getItem("vista")) {
                        listarParecerAluno(disciplinaId, firstPeriodo.dt_inicio, firstPeriodo.dt_fim);
                        listarPareceres(disciplinaId, firstPeriodo.dt_inicio, firstPeriodo.dt_fim);
                    }
                } else {
                    setSemPeriodos(true);
                    setIconLoading(false);
                    openNotificationWithIcon("warning", "Atenção", "Não foram adicionados períodos ao curso!");
                }
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
            });
    };

    const listarDisciplinas = () => {
        axios({
            method: "get",
            url: "/api/aulas/listar-turma-disciplinas",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const disciplinaNomeFormatado = disciplinaNome.toLowerCase().trim();
                const novaDiscipilinaId = response.data.find(disc => disc.nome.toLowerCase().trim() === disciplinaNomeFormatado)?.id;

                setDisciplinaId(novaDiscipilinaId);
                setDisciplinas(response.data);
                setIconLoading(false);

                if (novaDiscipilinaId !== undefined) {
                    listarParecerAluno(novaDiscipilinaId, dtInicio, dtFim);
                    listarPareceres(novaDiscipilinaId, dtInicio, dtFim);
                }
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar as disciplinas!");
            });
    };

    const handleSelect = novaDiscipilinaId => {
        if (novaDiscipilinaId) {
            const nome = disciplinas.find(x => x.id === novaDiscipilinaId)?.nome;
            setDisciplinaId(novaDiscipilinaId);
            setDisciplinaNome(nome);
            listarParecerAluno(novaDiscipilinaId, dtInicio, dtFim);
            listarPareceres(novaDiscipilinaId, dtInicio, dtFim);
        } else {
            setDisciplinaId(undefined);
            setDisciplinaNome("");
            setAulasAlunos([]);
            setAulas([]);
        }
    };

    const handleSelectDisciplina = opcao => {
        const disciplinaIdLocal = opcao;

        setDisciplinaId(disciplinaIdLocal);
    };

    const selectDiscipline = opcao => {
        handleSelectDisciplina(opcao);
    };

    const anteriorProximo = novoNum => {
        const periodo = periodos[novoNum - 1];

        setNum(novoNum);
        setPeriodoId(periodo.id);
        setTitulo(periodo.titulo);
        setDtInicio(periodo.dt_inicio);
        setDtFim(periodo.dt_fim);
        setIconLoading(true);

        listarParecerAluno(disciplinaId, periodo.dt_inicio, periodo.dt_fim);
        listarPareceres(disciplinaId, periodo.dt_inicio, periodo.dt_fim);
    };

    const descarregarParecerDescritivoEmMassa = dataEmissao => {
        setBtnDescarregar(true);
        setVisibleExportar(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-em-massa",
            params: {
                cursoId: localStorage.getItem("codigo_curso"),
                periodoId,
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                setBtnDescarregar(false);
                setFicheiroExportar(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível descarregar o documento!");
                setVisibleExportar(true);
            });
    };

    const exportarPdf = () => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-alunos-geral",
            params: {
                cursoId: disciplinaId,
                periodoId
            }
        })
            .then(response => {
                setVisibleLoading(false);
                setVisibleViewer(true);
                setDocs([{ uri: response.data }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleLoading(false);
            });
    };

    const exportarGeraisPdf = () => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-turma-geral",
            params: {
                cursoId: disciplinaId,
                periodoId
            }
        })
            .then(response => {
                const { url, fileName } = response.data;
                setVisibleLoading(false);
                setVisibleViewer(true);
                setDocs([{ uri: url, fileName }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleLoading(false);
            });
    };

    const exportarAnualPdf = dataEmissao => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-anual",
            params: {
                turmaId: disciplinaId,
                utilizadorId: alunoId,
                dataEmissao: dataEmissao?.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;
                setVisibleLoading(false);
                setVisibleViewer(true);
                setDocs([{ uri: url, fileName }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleLoading(false);
            });
    };

    const guardarAnual = texto => {
        const tempParticipantes = [...participantesAnual];
        const index = tempParticipantes.findIndex(x => x.id === parecerDrawer?.participante?.id);

        tempParticipantes[index].parecer_anual = texto;
        setParticipantesAnual(tempParticipantes);
    };

    useEffect(() => {
        tituloPareceres();

        if (localStorage.getItem("vista") === "TURMA") listarDisciplinas();
        if (localStorage.getItem("entidade_id") === "37") {
            alterarAcessoParecerAnual();
            carregarParecerAnual();
        }

        fetchTotal();
    }, []);

    useEffect(() => {
        if (localStorage.getItem("entidade_id") === "37") {
            carregarParecerAnual();
        }
    }, [disciplinaId]);

    useEffect(() => {
        if (location.pathname !== previousLocation.pathname && previousLocation !== "") {
            const novaDisciplinaId = localStorage.getItem("vista") === "TURMA" ? undefined : localStorage.getItem("codigo_curso");
            setDisciplinaId(novaDisciplinaId);

            if (localStorage.getItem("vista") === "TURMA") listarDisciplinas();
            if (localStorage.getItem("entidade_id") === "37") {
                alterarAcessoParecerAnual();
                carregarParecerAnual();
            }

            fetchTotal();
        }
        setPreviousLocation(location);
    }, [location.pathname]);

    const pareceresAcesso = context.acessos?.find(x => x.func === 31);

    return (
        <>
            <div className="container container-body">
                <div className="bloco-curso-diario-opcoes" style={{ gap: 10 }}>
                    <h3 className="titulo-bloco">Pareceres</h3>
                    <div className="bloco-opcoes-esquerda">
                        <Link
                            to={`/gerir-multisseriado/${match.params.turma}/${
                                localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                            }`}
                            className="botao-secundario botao-secundario-redondo"
                            title="Voltar"
                            style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                        >
                            <Icon type="arrow-left" />
                        </Link>
                    </div>
                </div>

                {localStorage.getItem("entidade_id") === "37" && participantesAnual?.length > 0 && (
                    <div className="curso-diario">
                        <div className="bloco-controlos-frequencia">
                            <div className={localStorage.getItem("vista") === "TURMA" ? "filters-parecer" : "filters-parecer-disciplina"}>
                                {localStorage.getItem("vista") === "TURMA" && (
                                    <Select
                                        className="filter"
                                        placeholder="Selecionar Disciplina"
                                        name="disciplinas"
                                        allowClear={true}
                                        onChange={selectDiscipline}
                                        disabled={disciplinas.length === 0}
                                    >
                                        {disciplinas.map(disciplina => (
                                            <Option key={disciplina.id} value={disciplina.id}>
                                                {disciplina.nome}
                                            </Option>
                                        ))}
                                    </Select>
                                )}

                                {isEIOuroBrancoAnosPosteriores && (
                                    <div className="controlos controlos-fundo ">
                                        <div className="bloco-esquerda"></div>
                                        <div className="bloco-direita">
                                            {pareceresAcesso?.read && !parecerAnualBloqueado && (
                                                <Link
                                                    className="botao-icon-bloquear"
                                                    to={"#"}
                                                    title="Pareceres"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setModalBloquearVisible(true);
                                                    }}
                                                >
                                                    <LuSend />
                                                    Finalizar e Entregar Pareceres
                                                </Link>
                                            )}
                                            {parecerAnualBloqueado && (
                                                <div style={{ display: "flex", gap: 5 }}>
                                                    <LuCheck style={{ color: "green", fontSize: 20 }} />
                                                    Entregue em {moment(dataParecerAnualBloqueado).format("DD/MM/YYYY")}
                                                </div>
                                            )}
                                            {pareceresAcesso?.update && (
                                                <>
                                                    <Link
                                                        className="botao-icon-desbloquear"
                                                        to={"#"}
                                                        title="Pareceres"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            setModalDesbloquearVisible(true);
                                                        }}
                                                    >
                                                        <Icon type="unlock" />
                                                        Reabrir para Edição
                                                    </Link>
                                                    <Dropdown
                                                        overlay={() => (
                                                            <Menu>
                                                                <Menu.Item>
                                                                    <Link
                                                                        to="#"
                                                                        onClick={e => {
                                                                            e.preventDefault();
                                                                            setVisibleDrawerLogs(true);
                                                                        }}
                                                                    >
                                                                        Logs
                                                                    </Link>
                                                                </Menu.Item>
                                                            </Menu>
                                                        )}
                                                        placement="bottomLeft"
                                                    >
                                                        <Link to="#" className="botao-icon-configs">
                                                            <i className="fas fa-cog" />
                                                        </Link>
                                                    </Dropdown>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <Collapse defaultActiveKey={[]} className="collapse-diario-observacoes">
                            <Panel
                                header={
                                    <span
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%"
                                        }}
                                    >
                                        <label>Parecer Descritivo Anual</label>
                                    </span>
                                }
                                key="1"
                            >
                                <div className="bloco-diario-observacoes">
                                    <ul className="lista-observacoes">
                                        {participantesAnual?.map(participante => (
                                            <li key={participante.id} className="item-observacoes">
                                                <div
                                                    className="info-participante"
                                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                                >
                                                    <div className="container-img">
                                                        {participante.foto ? (
                                                            <img src={participante.foto} />
                                                        ) : (
                                                            participante.nome !== "" && <InitialsAvatar name={participante.nome} />
                                                        )}
                                                    </div>
                                                    <div className="info" style={{ flex: "fit-content" }}>
                                                        <span className="nome">{participante.nome}</span>
                                                        <p className="numero">{participante.numero}</p>
                                                    </div>
                                                    <div className="bloco-opcoes-esquerda" style={{ display: "flex", gap: 5 }}>
                                                        <Link
                                                            to="#"
                                                            className="botao-icon-editar"
                                                            title="Editar"
                                                            onClick={event => {
                                                                event.stopPropagation();
                                                                setDrawerAdicionarParecerAnualVisible(true);
                                                                setParecerDrawer({ participante });
                                                            }}
                                                        >
                                                            <Icon type="edit" />
                                                        </Link>
                                                        <Link
                                                            className="botao-icon-parecer-aluno"
                                                            to="#"
                                                            title="Visualizar"
                                                            onClick={event => {
                                                                event.stopPropagation();
                                                                setAlunoId(participante.id);
                                                                setDataEmissaoAlunoAnualVisible(true);
                                                            }}
                                                        >
                                                            <Icon type="profile" />
                                                        </Link>
                                                    </div>
                                                </div>
                                                <p dangerouslySetInnerHTML={{ __html: participante.parecer_anual }}></p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Panel>
                        </Collapse>
                    </div>
                )}

                {!isEIOuroBrancoAnosPosteriores && (
                    <div className="curso-diario">
                        <div className="bloco-controlos-frequencia">
                            <div className="filters">
                                <div>
                                    {localStorage.getItem("vista") === "TURMA" && (
                                        <Select
                                            value={disciplinaId}
                                            className="filter"
                                            placeholder="Selecionar Disciplina"
                                            name="disciplinas"
                                            allowClear={true}
                                            onChange={handleSelect}
                                        >
                                            {disciplinas.map(disciplina => (
                                                <Option key={disciplina.id} value={disciplina.id}>
                                                    {disciplina.nome}
                                                </Option>
                                            ))}
                                        </Select>
                                    )}
                                </div>
                                {!semPeriodos && (
                                    <div>
                                        <Button
                                            className="botao-periodo botao-periodo-anterior"
                                            disabled={num === 1 || (localStorage.getItem("vista") === "TURMA" && !disciplinaId)}
                                            style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                            onClick={() => anteriorProximo(num - 1)}
                                        >
                                            <Icon type="left" />
                                        </Button>
                                        <span>{titulo}</span>
                                        <Button
                                            className="botao-periodo botao-periodo-proximo"
                                            disabled={
                                                num === periodos.length || (localStorage.getItem("vista") === "TURMA" && !disciplinaId)
                                            }
                                            style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                            onClick={() => anteriorProximo(num + 1)}
                                        >
                                            <Icon type="right" />
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <Collapse defaultActiveKey={[]} className="collapse-diario-observacoes">
                            <Panel
                                header={
                                    <span
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%"
                                        }}
                                    >
                                        <label>{parecer}</label>
                                        <span style={{ display: "flex", gap: 10 }}>
                                            <Link
                                                className={`botao-icon-detalhe ${
                                                    localStorage.getItem("vista") === "TURMA" && !disciplinaId ? "botao-disabled" : ""
                                                }`}
                                                to="#"
                                                title="Visualizar"
                                                disabled={localStorage.getItem("vista") === "TURMA" && !disciplinaId}
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    exportarPdf();
                                                }}
                                            >
                                                <Icon type="eye" />
                                            </Link>
                                        </span>
                                    </span>
                                }
                                key="1"
                            >
                                {!aulasAlunos.length ? "Sem dados..." : null}
                                {aulasAlunos.map((aula, index) => (
                                    <ParecerAluno key={index} aula={aula} participantes={participantes} />
                                ))}
                            </Panel>
                            <Panel
                                header={
                                    <span
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%"
                                        }}
                                    >
                                        <label>{geralParecer}</label>
                                        <span style={{ display: "flex", gap: 10 }}>
                                            <Link
                                                className={`botao-icon-detalhe ${
                                                    localStorage.getItem("vista") === "TURMA" && !disciplinaId ? "botao-disabled" : ""
                                                }`}
                                                to="#"
                                                title="Visualizar"
                                                disabled={localStorage.getItem("vista") === "TURMA" && !disciplinaId}
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    exportarGeraisPdf();
                                                }}
                                            >
                                                <Icon type="eye" />
                                            </Link>
                                        </span>
                                    </span>
                                }
                                key="2"
                            >
                                {!aulas.length ? "Sem dados..." : null}
                                {aulas.map((aula, index) => (
                                    <ParecerGeral key={index} aula={aula} />
                                ))}
                            </Panel>
                        </Collapse>
                    </div>
                )}
            </div>
            <Modal visible={iconLoading} maskClosable={false} className="modal-loading" footer={null} closable={false}>
                <div className="modal-loading-bloco">
                    <p>
                        <Icon type="loading" />
                    </p>
                    <p className="texto">A carregar...</p>
                </div>
            </Modal>

            <Modal
                visible={modalBloquearVisible}
                title="Finalizar e Entregar"
                okText="Confirmar"
                cancelText="Cancelar"
                onCancel={() => setModalBloquearVisible(false)}
                onOk={() => {
                    // lógica de bloquear aqui
                    alterarAcessoParecerAnual(true);
                    setModalBloquearVisible(false);
                }}
            >
                <p>
                    Tem a certeza que pretende finalizar e entregar estes pareceres? Após a entrega, os campos ficarão bloqueados para
                    edição.
                </p>
            </Modal>

            <Modal
                visible={modalDesbloquearVisible}
                title="Reabrir para Edição"
                okText="Confirmar"
                cancelText="Cancelar"
                onCancel={() => setModalDesbloquearVisible(false)}
                onOk={() => {
                    // lógica de desbloquear aqui
                    alterarAcessoParecerAnual(false);
                    setModalDesbloquearVisible(false);
                }}
            >
                <p>Tem a certeza que pretende reabrir os pareceres para edição?</p>
            </Modal>

            <DrawerLogs
                turmaId={!disciplinaId ? localStorage.getItem("codigo_curso") : disciplinaId}
                visible={visibleDrawerLogs}
                onClose={() => setVisibleDrawerLogs(false)}
            />

            <ModalGerarDocumento
                visibleExportar={visibleExportar}
                ficheiroExportar={ficheiroExportar}
                btnDescarregar={btnDescarregar}
                onClose={() => setVisibleExportar(false)}
            />
            <DrawerDataEmissao
                visible={dataEmissaoAlunoAnualVisible}
                onClose={() => setDataEmissaoAlunoAnualVisible(false)}
                onConfirm={dataEmissao => {
                    exportarAnualPdf(dataEmissao);
                    setDataEmissaoAlunoAnualVisible(false);
                }}
            />
            <ModalLoading visible={visibleLoading} text="A gerar documento..." />
            <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />
            <ModalAta
                visible={ataVisible}
                onClose={() => setAtaVisible(false)}
                onConfirm={dataEmissao => {
                    descarregarParecerDescritivoEmMassa(dataEmissao);
                    setAtaVisible(false);
                }}
            />
            <FormDrawerAdicionarParecerAnual
                disciplinaId={localStorage.getItem("codigo_curso")}
                parecerInfo={parecerDrawer}
                visible={drawerAdicionarParecerAnualVisible}
                onClose={() => setDrawerAdicionarParecerAnualVisible(false)}
                onConfirm={texto => {
                    guardarAnual(texto);
                    setDrawerAdicionarParecerAnualVisible(false);
                }}
            />
        </>
    );
};

export default withRouter(ListaPareceres);
